import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import SPECIMEN from '../../content/specimenOpinion';

/**
 * Illustrative sample Opinion — frozen pipeline output, not a live analysis.
 * Opinion No. 1001 is reserved in the specimen band.
 */
const SampleBriefingModal = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="mk-modal-root" role="dialog" aria-modal="true" aria-labelledby="sample-title">
      <button type="button" className="mk-modal-backdrop" aria-label="Close" onClick={onClose} />
      <div className="mk-modal mk-modal-wide">
        <button type="button" className="mk-modal-close" onClick={onClose} aria-label="Close dialog">
          <X size={18} />
        </button>
        <p className="mk-eyebrow">Illustrative sample · Opinion No. {SPECIMEN.opinionNumber}</p>
        <h2 id="sample-title" className="mk-modal-title">
          {SPECIMEN.company}
        </h2>
        <p className="mk-sample-basis">
          {SPECIMEN.basis}. {SPECIMEN.opinionDate}. Illustrative. Not a filing, and not an issued Opinion.
        </p>

        <div className="mk-opinion">
          {(SPECIMEN.opinionRows || []).map((row) => (
            <p key={row.text}>{row.text}</p>
          ))}
        </div>
        <div className="mk-figures">
          {(SPECIMEN.figureRows || []).map((row) => (
            <div key={row.label}>
              <span>{row.label}</span>
              <strong>{row.value}</strong>
            </div>
          ))}
        </div>

        <div className="mk-sample-block">
          <span className="mk-kicker">Evidence</span>
          <ul className="mk-checklist">
            {SPECIMEN.evidence.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        </div>

        <div className="mk-sample-two">
          <div>
            <span className="mk-kicker">Procurement</span>
            <p>{SPECIMEN.procurement}</p>
          </div>
          <div>
            <span className="mk-kicker">Treasury</span>
            <p>{SPECIMEN.treasury}</p>
          </div>
        </div>

        <div className="mk-sample-block">
          <span className="mk-kicker">What would change this Opinion</span>
          <p>{SPECIMEN.falsifier.improving}</p>
          <p>{SPECIMEN.falsifier.worsening}</p>
        </div>

        <p className="mk-sample-cadence">
          Methodology {SPECIMEN.methodologyVersion} · Rubric {SPECIMEN.rubricVersion}
        </p>

        <div className="mk-modal-actions">
          <button type="button" className="mk-btn mk-btn-primary" onClick={onClose}>
            Close sample
          </button>
        </div>
      </div>
    </div>
  );
};

export default SampleBriefingModal;
